import { Store } from "../../types/contexts/paycheckContext/store.types";

const initialState: Store = {
	paycheck: null
};

export default initialState;
